"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zListInvoicesQuery = exports.zVoidInvoiceRequest = exports.INVOICE_LINE_SECTIONS = exports.INVOICE_STATUSES = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
exports.INVOICE_STATUSES = ["open", "partially_paid", "paid", "void"];
exports.INVOICE_LINE_SECTIONS = ["parts", "labor", "sublet"];
exports.zVoidInvoiceRequest = zod_1.z.object({ reason: zod_1.z.string().trim().min(1) });
exports.zListInvoicesQuery = zod_1.z.object({
    // "unpaid" is a synthetic value (not a real InvoiceStatus) meaning
    // status IN ('open','partially_paid') — matches the dashboard's own
    // "Unpaid Invoices" figure, which is exactly that combination; see
    // InvoicesService.list(). Multi-select: repeat `?status=` for each pill
    // the shop has toggled on (see zMultiValueQueryParam) — OR'd together.
    status: (0, query_params_js_1.zMultiValueQueryParam)(zod_1.z.union([zod_1.z.enum(exports.INVOICE_STATUSES), zod_1.z.literal("unpaid")])),
    customerId: zod_1.z.coerce.number().int().positive().optional(),
    workOrderId: zod_1.z.coerce.number().int().positive().optional(),
    // Matches invoice number or customer number (exact), customer name or
    // phone (substring), or a dollar amount (exact, against total OR
    // balance due) — see InvoicesService.list().
    search: zod_1.z.string().trim().min(1).optional(),
    // A void invoice can be archived (hidden from the default list, never
    // deleted — see invoices.archivedAt's own doc comment). The default list
    // excludes archived invoices; setting this instead switches the list to
    // ONLY archived invoices, rather than adding them alongside the rest.
    onlyArchived: query_params_js_1.zBooleanQueryParam.default(false),
    // Column headers on the list page are clickable — see
    // InvoicesService.list()'s own whitelist mapping each of these to a real
    // ORDER BY expression. Defaults (unset) to the pre-existing
    // issuedOn-desc/invoiceNumber-desc order.
    sortBy: zod_1.z.enum(["issuedOn", "invoiceNumber", "customerName", "amountPaid", "balanceDue", "status"]).optional(),
    sortDirection: zod_1.z.enum(["asc", "desc"]).default("desc"),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=invoices.js.map